import React, { useState } from "react";
import { assets } from "../../../Assets/assets";
import HeadingText from './../../common/HeadingText';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How do I start the home buying process?",
      answer:
        "Begin by assessing your budget and getting pre-approved for a mortgage. Then, start searching for homes that meet your needs.",
    },
    {
      question: "What costs are involved in buying a home?",
      answer:
        "Common costs include the down payment, closing fees, inspection charges, and taxes.",
    },
    {
      question: "How long does it take to buy a home?",
      answer:
        "Typically, it takes 30 to 60 days from offer acceptance to closing, depending on financing and inspections.",
    },
    {
      question: "Can I buy a home without a real estate agent?",
      answer:
        "Yes, but working with an experienced agent can make the process smoother and help you negotiate better deals.",
    },
    {
      question: "Do I need to sell my current home before buying a new one?",
      answer:
        "Not always. Some people buy first and then sell, while others sell first to avoid overlapping mortgages.",
    },
  ];

  return (
    <section className="bg-white py-8 xl:px-20 px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <HeadingText label={'FAQs'} heading={'Ask Us anything'} />

          <div className="md:space-y-4 space-y-3 mt-5">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border-b border-gray-200 pb-4 cursor-pointer group"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium transition-colors duration-200 group-hover:text-[#E4E95B]">
                    {faq.question}
                  </h3>
                  <span className="text-2xl font-light transition-transform duration-300">
                    {openIndex === index ? "−" : "+"}
                  </span>
                </div>

                <div
                  className={`transition-all duration-500 ease-in-out overflow-hidden ${openIndex === index
                    ? "max-h-40 opacity-100 mt-3"
                    : "max-h-0 opacity-0"
                    }`}
                >
                  <p className="text-secondaryTextColor text-sm md:text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className="relative md:h-[30rem] h-[25rem] rounded-2xl overflow-hidden self-start"
          style={{
            backgroundImage: `url(${assets.faqBanner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="bg-black/30 p-10 md:p-12 text-white h-full flex flex-col">
            <h2 className="xl:text-5xl sm:text-4xl text-3xl font-semibold mb-4">
              Get in Touch With Us
            </h2>
            <p className="mb-8 font-medium leading-relaxed">
              Reach out today for expert real estate advice, personalized
              support, and a dedicated team ready to guide you every step of the
              way.
            </p>
            {/* <button className="bg-black text-white lg:px-6 px-3 text-sm md:text-base py-3 rounded-md font-medium hover:text-black hover:bg-[#E4E95B] transition-transform duration-300 hover:-translate-y-1 w-fit">
              Schedule a Consultation
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
